import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { switchToAccount } from '../../actions/Auth';
import { showModal } from '../../actions';

import DateTime from '../DateTime';

import { formatBytes } from '../../helpers/Files';

const getAccountPlan = (client) => {
  if (client.is_complimentary) {
    return 'complimentary';
  }

  if (client.is_in_trial) {
    return 'trial';
  }

  if (client.manual_subscription && client.is_active) {
    if (client.plan_name) {
      return client.plan_name;
    }
    return 'paid';
  }

  if (client.is_subscribed && client.is_active) {
    if (client.plan_name) {
      return client.plan_name;
    }
    return 'paid';
  }

  if (client.payment_disabled) {
    return 'legacy';
  }

  if (client.is_free) {
    return 'free';
  }

  return '';
};

const AdminPanelClientListItem = ({
  dispatch,
  client,
  afterClientDeleted,
  afterClientUpdated,
}) => {
  const handleSwitchToAccount = (e) => {
    e.preventDefault();
    switchToAccount(client.uuid, true);
  };

  const handleOpenEditModal = (e) => {
    e.preventDefault();
    dispatch(showModal('AdminPanelAccountsEditModal', {
      className: 'modal-admin-account-edit-modal',
      clientUuid: client.uuid,
      afterClientUpdated: () => { afterClientUpdated(client); },
    }));
  };

  const handleOpenDeleteModal = (e) => {
    e.preventDefault();
    dispatch(showModal('AdminPanelAccountsDeleteModal', {
      className: 'modal-admin-account-delete-modal',
      clientUuid: client.uuid,
      afterClientDeleted: () => { afterClientDeleted(client); },
    }));
  };

  return (
    <tr className={classnames({ 'not-activated': client.activated_users === 0 })}>
      <th scope="row">
        {client.display_name}
        <span className="account-url">
          <a id={`switch-${client.uuid}`} href={client.host} onClick={handleSwitchToAccount}>
            {client.domain}{' '}
            <i className="fa-regular fa-up-right-from-square" />
          </a>
        </span>
      </th>
      <td>
        <DateTime
          id={`client-created-${client.uuid}`}
          dateTime={client.created_at}
        />
      </td>
      <td>
        {getAccountPlan(client)}
      </td>
      <td>
        {client.users} / {client.activated_users}
      </td>
      <td>
        {client.storage_limit ? (
          formatBytes(client.storage_limit)
        ) : (
          '--'
        )}
      </td>
      <td>
        {client.storage_limit ? (
          `${formatBytes(client.used_storage)} (${client.used_storage_percentage}%)`
        ) : (
          '--'
        )}
      </td>
      <td>
        <a href="#manage" onClick={handleOpenEditModal}>
          <i className="far fa-edit" />
        </a>
        {' '}
        <a href="#delete" onClick={handleOpenDeleteModal}>
          <i className="far fa-trash" />
        </a>
      </td>
    </tr>
  );
};

AdminPanelClientListItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
  afterClientDeleted: PropTypes.func.isRequired,
  afterClientUpdated: PropTypes.func.isRequired,
};

export default connect()(AdminPanelClientListItem);
